//
//  SDKBlurType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Connection providers enum
export var ConnectionProviders;
(function (ConnectionProviders) {
    ConnectionProviders["github"] = "github";
    ConnectionProviders["gitlab"] = "gitlab";
    ConnectionProviders["bitbucket"] = "bitbucket";
    ConnectionProviders["azure"] = "azure";
})(ConnectionProviders || (ConnectionProviders = {}));
